export default {
  data: () => ({
    NET_PRICE: {
      key: 'net',
      isNet: true,
      label: 'kwota netto'
    },
    GROSS_PRICE: {
      key: 'gross',
      isNet: false,
      label: 'kwota brutto'
    }
  }),
  methods: {
    getPriceTypeLabel(isNet) {
      return isNet ? this.NET_PRICE.label : this.GROSS_PRICE.label
    },
    getPriceTypes() {
      return [this.NET_PRICE, this.GROSS_PRICE]
    }
  }
}
